import { template as template_4fb2e4277d864e66ac422f05ee001b51 } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import pick from 'ember-composable-helpers/helpers/pick';
import t from 'ember-intl/helpers/t';
export default template_4fb2e4277d864e66ac422f05ee001b51(`
  <div class="row">
    <div class="col-12" data-test-reason-for-visit>
      <label class="required" for="waitlist-reason-for-visit">
        {{t "site.waitlistIntake.fields.reasonForVisit"}}
      </label>
      <RequestValidatedInput @model={{@form}} @path="reasonForVisit" @isDirty={{@form.isDirty}}>
        <textarea
          id="waitlist-reason-for-visit"
          name="reasonForVisit"
          rows="5"
          value={{@form.reasonForVisit}}
          {{on "input" (pick "target.value" (fn @onUpdate "reasonForVisit"))}}
        ></textarea>
      </RequestValidatedInput>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
